/* import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateDiff',
  pure: false
})
export class DateDifferencePipe implements PipeTransform, OnDestroy {
  private intervalId: any;

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  transform(start: string, end?: string): string {
    this.removeTimer();
    this.intervalId = setInterval(() => {
      this.changeDetectorRef.markForCheck();
    }, 1000);

    let startDate = moment(start, 'DD/MM/YYYY', true);
    if (!startDate.isValid()) startDate = moment(start);
    let endDate = end ? moment(end, 'DD/MM/YYYY', true) : moment();
    if (end && !endDate.isValid()) endDate = moment(end);

    for (const unit of ['years', 'months', 'days', 'hours', 'minutes', 'seconds'] as const) {
      let diff = endDate.diff(startDate, unit);
      if (diff !== 0) {
        diff = Math.abs(diff);
        return `${diff} ${diff === 1 ? unit.slice(0, -1) : unit}`;
      }
    }

    return '0 seconds';
  }

  private removeTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnDestroy() {
    this.removeTimer();
  }
} */

/* import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject, interval } from 'rxjs';

@Pipe({
  name: 'dateDiff',
  pure: false
})
export class DateDifferencePipe implements PipeTransform, OnDestroy {
  private intervalId: any;
  private diffSubject: BehaviorSubject<string> = new BehaviorSubject<string>('0 seconds');

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.startInterval();
  }

  transform(start: string, end?: string): string {
    this.updateDifference(start, end);
    return this.diffSubject.getValue();
  }

  private startInterval() {
    this.intervalId = interval(1000).subscribe(() => {
      this.changeDetectorRef.markForCheck();
    });
  }

  private updateDifference(start: string, end?: string) {
    let startDate = moment(start, 'DD/MM/YYYY', true);
    if (!startDate.isValid()) startDate = moment(start);
    let endDate = end ? moment(end, 'DD/MM/YYYY', true) : moment();
    if (end && !endDate.isValid()) endDate = moment(end);

    for (const unit of ['years', 'months', 'days', 'hours', 'minutes', 'seconds'] as const) {
      let diff = endDate.diff(startDate, unit);
      if (diff !== 0) {
        diff = Math.abs(diff);
        this.diffSubject.next(`${diff} ${diff === 1 ? unit.slice(0, -1) : unit}`);
        return;
      }
    }

    this.diffSubject.next('0 seconds');
  }

  private removeTimer() {
    if (this.intervalId) {
      this.intervalId.unsubscribe();
      this.intervalId = null;
    }
  }

  ngOnDestroy() {
    this.removeTimer();
  }
}
 */

import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { interval, Subscription } from 'rxjs';

@Pipe({
  name: 'dateDiff',
  pure: false
})
export class DateDifferencePipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;
  private lastValue: string = '0 seconds';
  private startTime?: string;
  private endTime?: string;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.subscription = interval(1000).subscribe(() => {
      this.updateDifference();
      this.changeDetectorRef.markForCheck();
    });
  }

  transform(start: string, end?: string): string {
    if (!start) {
      return '';
    }
    if (this.startTime !== start || this.endTime !== end) {
      this.startTime = start;
      this.endTime = end;
      this.updateDifference();
    }
    return this.lastValue;
  }

  private updateDifference() {
    if (!this.startTime) {
      this.lastValue = '';
      return;
    }
    
    let startDateMoment = moment.utc(this.startTime, 'DD/MM/YYYY', true);
    if (!startDateMoment.isValid()) {
      startDateMoment = moment.utc(this.startTime);
    }

    // If an end date is provided, calculate calendar day difference
    if (this.endTime) {
      let endDateMoment = moment.utc(this.endTime, 'DD/MM/YYYY', true);
      if (!endDateMoment.isValid()) {
        endDateMoment = moment.utc(this.endTime);
      }

      const startDay = startDateMoment.startOf('day');
      const endDay = endDateMoment.startOf('day');
      const diffDays = endDay.diff(startDay, 'days');

      if (diffDays >= 0) {
        // Add 1 to make the day count inclusive (counts both start and end day)
        const inclusiveDays = diffDays + 1;
        this.lastValue = `${inclusiveDays} ${inclusiveDays === 1 ? 'day' : 'days'}`;
      } else {
        // This case would mean discharge is before admission.
        this.lastValue = '0 days';
      }
      return;
    }

    // Original logic for single-date, relative-time calculations (e.g., "x minutes ago")
    const endDate = moment.utc();
    for (const unit of ['years', 'months', 'days', 'hours', 'minutes', 'seconds'] as const) {
      let diff = endDate.diff(startDateMoment, unit);
      if (diff !== 0) {
        diff = Math.abs(diff);
        this.lastValue = `${diff} ${diff === 1 ? unit.slice(0, -1) : unit}`;
        return;
      }
    }

    this.lastValue = '0 seconds';
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
